import { render } from "./AposArrayEditor.vue?vue&type=template&id=5438ba8b&scoped=true"
import script from "./AposArrayEditor.vue?vue&type=script&lang=js"
export * from "./AposArrayEditor.vue?vue&type=script&lang=js"

import "./AposArrayEditor.vue?vue&type=style&index=0&id=5438ba8b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5438ba8b"],['__file',"schema/ui/apos/components/AposArrayEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5438ba8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5438ba8b', __exports__)) {
    api.reload('5438ba8b', __exports__)
  }
  
  module.hot.accept("./AposArrayEditor.vue?vue&type=template&id=5438ba8b&scoped=true", () => {
    api.rerender('5438ba8b', render)
  })

}


export default __exports__